import { COMMON_SKIP_ENCRYPTION_PATHS } from "configs/encryptionConfigs";

const dev = {
  API_ENDPOINT_URL: "http://127.0.0.1:8000",
  // API_ENDPOINT_URL: "http://192.168.29.222:8000/",
  // API_ENDPOINT_URL: "http://192.168.29.229:8000/",
  // API_ENDPOINT_URL: "http://192.168.29.229:8000",
  // API_ENDPOINT_URL: "http://192.168.29.71:9000/",
  CDN_ENDPOINT_URL: "https://cdn-demo.mitelensman-uat.com/",
  YT_URL: "https://www.youtube.com/embed/",
  AES_KEY: "7x9Kp2Vm8Qr4Hn6Wz3Lc5Gt1Yb0Xs9Mf",
  SKIP_ENCRYPTION_PATHS: COMMON_SKIP_ENCRYPTION_PATHS,
  AES_ENCRYPTION_IV: "G9#dL!rZp@4qXe8M",
};

const demo = {
  CDN_ENDPOINT_URL: "https://cdn-demo.mitelensman-uat.com/",
  API_ENDPOINT_URL: "https://demo-lensman.mitetechnology.in/",
  AES_KEY: "7x9Kp2Vm8Qr4Hn6Wz3Lc5Gt1Yb0Xs9Mf",
  AES_ENCRYPTION_IV: "G9#dL!rZp@4qXe8M",
  SKIP_ENCRYPTION_PATHS: COMMON_SKIP_ENCRYPTION_PATHS,
};
// temp
const prod = {
  CDN_ENDPOINT_URL: "https://cdn.mitelensman.com/",
  API_ENDPOINT_URL: "https://api.mitelensman.com/",
  AES_KEY: "Bq8Zv4Nm7Rw2Kx5Jt9Pu6Hd3Gy1Lc0Zs",
  SKIP_ENCRYPTION_PATHS: COMMON_SKIP_ENCRYPTION_PATHS,
  AES_ENCRYPTION_IV: "G9#dL!rZp@4qXe8M",
};

const test = {
  API_ENDPOINT_URL: "/api",
  AES_ENCRYPTION_IV: "G9#dL!rZp@4qXe8M",
  AES_KEY: "7x9Kp2Vm8Qr4Hn6Wz3Lc5Gt1Yb0Xs9Mf",
  CDN_ENDPOINT_URL: "https://cdn-demo.mitelensman-uat.com/",
};

const getEnv = () => {
  switch (process.env.REACT_APP_ENV) {
    case "demo":
      return demo;
    case "prod":
      return prod;
    case "production":
      return prod;
    case "development":
      return dev;
    case "test":
      return test;
    default:
      return dev; // Fallback to development
  }
};

export const env = getEnv();
